const OrganisationSettingsActions = {
    ADD_NEW_PROFILE_ACTION: "addNewProfileAction",
    ADD_PRODUCT_PREFERENCES_FOR_JOB_FUNCTION: "addProductPreferencesForJobFunction",
    ADD_ROOT_TREE_NODE_ACTION: "addRootTreeNodeAction",
    ADD_SELF_REGISTRATION_PROFILE: "addSelfRegistrationProfile",
    ADD_SUB_ORGANISATION_ACTION: "addSubOrganisationAction",
    ADD_TREE_NODE_ACTION: "addTreeNodeAction",
    ADD_USER_ACTION: "addUserAction",
    ADMIN_AMEND_ACTION: "adminAmendNameAction",
    ALLOW_ADDING_CLIENT_ADMIN_ROLE_ACTION: "allowAddingClientAdminRoleAction",
    AMEND_ACTION: "amendNameAction",
    AMEND_PROGRAM_ACTION: "amendProgramAction",
    AMEND_USER_ACTION: "amendUserAction",
    CAN_SEE_DILEMMA_TEST: "canSeeDilemmaTest",
    CAN_UPDATE_PROFILE_BILLING: "canUpdateProfileBilling",
    CHANGE_SCORE_SETTINGS_ACTION: "changeScoreSettingsAction",
    DEACTIVATE_JOB_FUNCTION_ACTION: "deactivateJobFunctionAction",
    DEACTIVATE_ORGANISATION_ACTION: "deactivateOrganisationAction",
    DEACTIVATE_USER_ACTION: "deactivateUserAction",
    EDIT_COMPETENCY_SELECTION: "editCompetencySelectionAction",
    EDIT_EMAILS_ACTION: "editEmailsAction",
    EDIT_ORGANISATION_BASIC_SETTINGS_ACTION: "editOrganisationBasicSettingsAction",
    EDIT_PRODUCT_SELECTION: "editProductSelectionAction",
    EDIT_PROJECT_BASIC_SETTINGS_ACTION: "editProjectBasicSettingsAction",
    EDIT_SELF_REGISTRATION_SETTINGS: "editSelfRegistrationSettings",
    EXPORT_API_SETTINGS: "exportApiSettings",
    EXPORT_USERS_ACTION: "exportUsersAction",
    FORCE_ENTRA_REGISTER_ACTION: "forceEntraRegisterAction",
    GET_API_SETTINGS_ACTION: "getApiSettingsAction",
    GET_BILLING_ACTION: "getBillingAction",
    GET_CONTACTS_ACTION: "getContactsAction",
    GET_PROFILE_BILLING_ACTION: "getProfileBillingAction",
    GET_SCORE_SETTINGS_ACTION: "getScoreSettingsAction",
    GET_SELF_REGISTRATION_ACTION: "getSelfRegistrationAction",
    GET_TREE_NODES_ACTION: "getTreeNodesAction",
    INVITE_USER_ACTION: "inviteUserAction",
    MANAGE_ORGANISATION_PRODUCT_PRICE_ACTION: "manageOrganisationProductPriceAction",
    MASQUERADE_AS_USER_ACTION: "masqueradeAsUserAction",
    PROFILE_ALIAS_ACTION: "profileAliasAction",
    SELECT_AUTHENTICATION_PROVIDER: "selectAuthenticationProvider",
    TOGGLE_MANDATORY_REFLECTION: "toggleMandatoryReflection",
    UPLOAD_ORGANISATION_LOGO: "uploadOrganisationLogo",
    VIEW_TAB_COMPETENCIES: "viewTab_competencies",
    VIEW_TAB_ORGANISATION_BASIC_SETTINGS: "viewTab_organisationBasicSettings",
    VIEW_TAB_PRODUCTS: "viewTab_products",
    VIEW_TAB_PROFILE_PRODUCTS_TAB: "viewTab_profileProductsTab",
    VIEW_TAB_PROJECT_BASIC_SETTINGS: "viewTab_projectBasicSettings",
    VIEW_TAB_USERS: "viewTab_users",
};

export default OrganisationSettingsActions;
